import React, { Component } from 'react';
import { PALETTE } from '../../../constants';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import LoginHeader from './login.header';
import Arrow from '../../../components/common/arrow';
import ui from '../../../../@extension/CH/src/data/ui.json';
import Parser from 'html-react-parser';
import { AboutDeutscheBankWealthManagement } from '@dbk/ui-icons';
import config from '../../../data/settings.json';
import { EBANKINGWEBLUX, EBANKINGWEBUK, EBANKINGWEB, RM_REGION, RM_ACCESS } from '../../../constants';
import envConfig from '../../../../db-env-build';
import Text, {H1, H4} from '@dbk/ui-text';
class LoginSecurity extends Component {

    constructor(props) {
        super(props);

        this.state = {
            securityList: []
        }
    }

    componentDidMount() {
        const { languages: { destLanguageCode }, auth: { setInvalidLogin } } = this.props;
        setInvalidLogin(false);
        const remoteUrl = window.location.origin + config.environments.relative.remoteUrl;
        let path;
        if (destLanguageCode === 'de-CH') {
            path = envConfig.rmRegion === RM_REGION ? ui.pdf.securityJsonGerman.replace("CH", "LUX") : ui.pdf.securityJsonGerman
        } else {
            path = envConfig.rmRegion === RM_REGION ? ui.pdf.securityJsonEnglish.replace("CH", "LUX") : ui.pdf.securityJsonEnglish
        }

        //let url = "https://int7.mywealthasia.intranet.db.com/ebanking" + path;  // for local testing
        let url = remoteUrl + path;
        fetch(url, {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Methods': 'DELETE, HEAD, GET, OPTIONS, POST, PUT',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'pragma': 'no-cache',
            'cache-control': 'no-store',
        })
            .then(resp => resp.json())
            .then((result) => {

                this.setState({
                    securityList: result,
                })
            }).catch((error) => {
                console.error(error);
            });
            if(document.querySelector('.security-title-focus')){
                document.querySelector('.security-title-focus').focus();
            }
            
    }


    render = () => {

        const { i18n: { messages }, ui: { history: { goBack } }, languages: { destLanguage }, auth: { authorised }, rmAccess } = this.props;

        return (
            <View className="login">
                {!authorised && (rmAccess.userAdminGroup !== RM_ACCESS.RM_DOC_UPLOAD) &&
                    <View className="login-container margin-bottom-30">
                        <LoginHeader />
                    </View >
                }
                <View className="faq-container">
                    <div className='display-flex-row'>
                        <div className='small-3 display-flex-row faq-title-container'>
                            <div className="cursor-pointer">
                                <a href="javascript:;" onClick={() => goBack()} role="button" aria-label={messages['app.documentUpload.button.back']}>
                                <Arrow
                                    direction="left"
                                    width={10}
                                    height={16}
                                    color={PALETTE.secondaryActive}
                                    thickness={2}
                                    id="arrow_backLink_test"
                                /></a></div>
                            <H1 className="font-size-36 padding-left-20 security-title-focus" tabIndex={0} testID="text_loginTitle_userLogin_test" >{messages['app.security.tips.title']}</H1>
                        </div>
                    </div>
                    <div className='display-flex-row'>
                        {/* Left Side Bar   */}
                        <div className="small-4 bg-blue-stay-safe padding-20 security-tips">
                            <div className="display-flex-row ">
                                <AboutDeutscheBankWealthManagement width={24} height={24} className="security" color={"#ffffff"}/>
                                <H4 className="margin-10" tabIndex={0}>{messages['app.security.tips.stay.safe']}</H4>
                            </div>
                            <div className="margin-top-10">
                                <Text tabIndex={0}>
                                {messages['app.security.tips.desc1']}<br/><br/>
                                </Text>
                                <Text tabIndex={0}>{messages['app.security.tips.desc2']} 
                                {/* {envConfig.envConfig === EBANKINGWEBLUX && <a href="mailto:dwo-lux.helpdesk@db.com"> {messages['app.security.tips.lux.helpdesk']}</a>}
                                {envConfig.envConfig === EBANKINGWEBUK && <a href="mailto:dwo-uk.helpdesk@db.com"> {messages['app.security.tips.uk.helpdesk']}</a>}
                                {envConfig.envConfig === EBANKINGWEB && <a href="mailto:dwo-ch.helpdesk@db.com"> {messages['app.security.tips.ch.helpdesk']}</a>}   */}
                                {/* {destLanguage === "Deutsch" && messages['app.security.tips.desc3']}   */}
                                </Text>
                            </div>

                        </div>
                        {/* Secutiry Tips */}
                        <div className='small-6 bg-dawn-blue padding-25 margin-left-20'>
                            {this.state.securityList.length > 0 ? this.state.securityList.map((item, index) =>
                                <div> 
                                    <H4 className="security-tips-list-header padding-left-15 padding-bottom-15 margin-10" tabIndex={0}>
                                    {item.category}
                                </H4>
                                    <ul>
                                        {Parser(item.list[0].tips).props.children.map((i)=>
                                            <li tabIndex={0} id="cust-dashboard-container">
                                                <Text size="large">
                                                    {i.props.children}
                                                </Text>
                                            </li>)
                                        }
                                    </ul>
                                    {/* <div id="cust-dashboard-container" tabIndex={0}>{Parser(item.list[0].tips)}</div> */}
                                </div>
                            ):   
                            <Text size="large" className ="security-tips-list-item" tabIndex={0} aria-label={messages['app.auth.vasco.activation.progress.generic.msg1']}> 
                                {messages['app.auth.vasco.activation.progress.generic.msg1']}
                            </Text>
                            }
                        </div>
                    </div>
                </View >
            </View>
        );
    }

}
export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        languages: {
            saveLanguageAtLogin: { $call: 'saveLanguageAtLogin' },
            getlanguages: { $call: 'getlanguages' },
            destLanguage: true,
            destLanguageCode: true,
        },
        config: {
            regionCode: true
        },
        changePage: { $call: 'ui.history.push' },
        ui: {
            history: {
                goBack: { $call: 'goBack' },
            }
        },
        auth: {
            authorised: true,
            setInvalidLogin: { $set: 'invalidLogin'}
        },
        rmAccess: {
            userAdminGroup: true
        }
    },
})(LoginSecurity);



